// @flow
import React, { useContext } from 'react';
import { Grid } from 'semantic-ui-react';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayStyledGridRow,
} from '@src/formik-utils/FieldArrayGrid';
import { CommitDimensionsConfigUpdateButtonContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/dimensions-configuration/CommitDimensionsConfigUpdateButtonContainer';
import { CommitDimensionsConfigDeleteButtonContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/dimensions-configuration/CommitDimensionsConfigDeleteButtonContainer';
import { CommitDependentDimensionsDropdownContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/dimensions-configuration/CommitDependentDimensionsDropdownContainer';
import { getIfCurrentVBDConflictsWithAnyMLD } from '@src/configuration/custom-discounts';
import { VBDConflictingRowMessageContainer } from '@components/common/vbd/VBDConflictingRowMessageContainer';
import { getIfRowIsVBD } from '@components/custom-discounts/utils';
import { VBDRibbonContainer } from '@components/common/vbd/VBDRibbonContainer';
import { If } from '@presentational/If';

export const CommitMetricsLevelDiscountsDimensionsConfigurationItem = () => {
  const { parentContext, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const isVBDRow = getIfRowIsVBD(rowValues);
  const completeDimensionsArray = parentContext?.dimensions_config_array ?? [];
  const { doesVBDRowConflictWithAnyOtherUserRow } = getIfCurrentVBDConflictsWithAnyMLD(
    completeDimensionsArray,
    rowValues,
    isVBDRow
  );

  return (
    <>
      <FieldArrayStyledGridRow>
        <If test={isVBDRow}>
          <VBDRibbonContainer
            doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
          />
        </If>
        <CommitDependentDimensionsDropdownContainer
          doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
          isVBDRow={isVBDRow}
        />
        <Grid.Column width={1}>
          <CommitDimensionsConfigUpdateButtonContainer />
        </Grid.Column>
        <Grid.Column width={1}>
          <CommitDimensionsConfigDeleteButtonContainer />
        </Grid.Column>
      </FieldArrayStyledGridRow>
      <VBDConflictingRowMessageContainer
        doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
        isVBDRow={isVBDRow}
      />
    </>
  );
};
